import { quoteCount } from '@/atoms/stats'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Event } from '@nostr/tools/wasm'
import { HugeiconsIcon } from '@hugeicons/react'
import { QuillWrite02Icon } from '@hugeicons/core-free-icons'
import { cn } from '@/lib/utils'
import { getNoteBech32Id } from '@/lib/event'
import { checkLogin } from '@/atoms/session'
import { useAtomValue } from 'jotai'
import PostEditor from '../PostEditor'
import { formatCount } from './utils'

export default function QuoteButton({ event }: { event: Event }) {
  const { t } = useTranslation()
  const count = useAtomValue(quoteCount(event.id))
  const [isPostDialogOpen, setIsPostDialogOpen] = useState(false)

  return (
    <>
      <button
        className={cn(
          'flex gap-1 items-center text-muted-foreground hover:text-lime-500 px-3 h-full'
        )}
        title={t('Quote')}
        onClick={(e) => {
          e.stopPropagation()
          checkLogin(() => {
            setIsPostDialogOpen(true)
          })
        }}
      >
        <HugeiconsIcon icon={QuillWrite02Icon} />
        {!!count && <div className="text-sm">{formatCount(count)}</div>}
      </button>
      <PostEditor
        open={isPostDialogOpen}
        setOpen={setIsPostDialogOpen}
        defaultContent={'\nnostr:' + getNoteBech32Id(event)}
      />
    </>
  )
}
